import { ModernSelect, SelectOption } from "@components/Select";
import { Box, SelectChangeEvent, Skeleton } from "@mui/material";
import { useClientModels } from "@services/api";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export interface ClientSelectorProps {
  selectedClient: string;
  selectedClientModel: string;
  setSelectedClientModel: (clientModelId: string) => void;
}

const ClientModelSelector = ({
  selectedClient,
  selectedClientModel,
  setSelectedClientModel
}: ClientSelectorProps) => {
  const { t } = useTranslation();

  const { data: models, isFetching: isLoading } =
    useClientModels(selectedClient);

  const onClientModelSelectChange = (event: SelectChangeEvent<string>) => {
    const clientModelId = event.target.value;
    setSelectedClientModel(clientModelId.toString());
  };

  const clientModelsOptions = useMemo(() => {
    return (models || [])
      .sort((a, b) => b.year - a.year)
      .reduce((acc, model) => {
        acc.push({
          value: model.id,
          label: model.name
        });
        return acc;
      }, [] as SelectOption[]);
  }, [models]);

  return (
    <Box className="flex justify-center w-full">
      {isLoading ? (
        <Skeleton variant="rectangular" width="100%" height={40} />
      ) : (
        <ModernSelect
          options={clientModelsOptions}
          value={selectedClientModel}
          onChange={onClientModelSelectChange}
          valueKey="id"
          labelKey="name"
          label={`${t("navbar.model")} *`}
          showIndicatorDot={true}
          colorTheme="light"
          id="mmm-model-ext-model-helper"
          disabled={isLoading}
        />
      )}
    </Box>
  );
};

export default ClientModelSelector;
